import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { registrationUser } from '../services/registration';
import { checkAuth, decodeToken, login } from '../services/autorization';
import { DataUserI, UserI } from '../interfaces/user';

const initialState: UserI = {
  id: '',
  role: '',
  name: '',
  isLogin: false,
  isLoading: true,
  responseCode: 0,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logOut: (state) => {
      localStorage.removeItem('dataPortal');
      state.id = '';
      state.isLogin = false;
      state.responseCode = 0;
      state.role = '';
      state.name = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action: PayloadAction<DataUserI>) => {
        const token = decodeToken(action.payload.token);
        state.isLogin = true;
        state.id = token.id;
        state.role = token.type;
        state.name = action.payload.lastName;
        state.responseCode = 0;
        state.isLoading = false;
      })
      .addCase(login.rejected, (state, action) => {
        //@ts-ignore
        state.responseCode = action.payload;
        state.isLoading = false;
      })
      .addCase(checkAuth.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(checkAuth.fulfilled, (state) => {
        //@ts-ignore
        const dataPortal = JSON.parse(localStorage.getItem('dataPortal'));
        const token = decodeToken(dataPortal.token);
        state.role = token.type;
        state.name = dataPortal.lastName;
        state.isLogin = true;
        state.id = token.id;
        state.isLoading = false;
      })
      .addCase(checkAuth.rejected, (state, action) => {
        localStorage.removeItem('dataPortal');
        state.isLoading = false;
      })
      .addCase(registrationUser.pending, (state) => {
        state.responseCode = 0;
      })
      .addCase(registrationUser.rejected, (state, action) => {
        //@ts-ignore
        state.responseCode = action.payload;
      });
  },
});
const { actions, reducer } = userSlice;
export default reducer;
export const { logOut } = actions;
